import { ICustomerAddress, ICustomerBasic } from "../Models/Customer";
import { IPvcUser, TPrivilages, TPvcCenterAddress } from "../Models/PVC";
import { TBasePricingParameters } from "../Models/PhysicalOrder";
import { METAL_TYPES, STATES, breakpoints } from "./constant";

export const objToArray = (obj: { [key: string]: string }) => {
  const array = [];

  for (let key in obj) {
    array.push({ key: key, value: obj[key] });
  }

  return array;
};

export const genId = () =>
  Math.random().toString(36).substring(2) +
  Math.random().toString(36).substring(2);

export const isMobile = () => window.innerWidth <= breakpoints.mobile;

export const toTitleCase = (str: string) =>
  str
    .split(" ")
    .filter((str)=> Boolean(str))
    .map((str) => str[0]?.toUpperCase() + str.substring(1))
    .join(" ");

export const getUserPrivilages = (user: IPvcUser) => {
  const { permissions } = user.role;

  const privilages: TPrivilages = {
    customer: { read: false, write: false },
    buyback: { read: false, write: false },
    buysell: { read: false, write: false },
    gms: { read: false, write: false },
    jobwork: { read: false, write: false },
    puritytesting: { read: false, write: false },
    admin: { all: false }
  };

  permissions.forEach((permission) => {
    switch (permission.name) {
      case "customer":
        privilages["customer"] = {
          read: permission.privilages.includes("read"),
          write: permission.privilages.includes("write"),
        };
        break;

      case "buysell":
        privilages["buysell"] = {
          read: permission.privilages.includes("read"),
          write: permission.privilages.includes("write"),
        };
        break;

      case "buyback":
        privilages["buyback"] = {
          read: permission.privilages.includes("read"),
          write: permission.privilages.includes("write"),
        };
        break;

      case "gms":
        privilages["gms"] = {
          read: permission.privilages.includes("read"),
          write: permission.privilages.includes("write"),
        };
        break;

      case "jobwork":
        privilages["jobwork"] = {
          read: permission.privilages.includes("read"),
          write: permission.privilages.includes("write"),
        };
        break;

      case "puritytesting":
        privilages["puritytesting"] = {
          read: permission.privilages.includes("read"),
          write: permission.privilages.includes("write"),
        };
        break;

      case "admin":
        privilages["admin"] = {
          all: permission.privilages.includes("all")
        };
        break;
    }
  });

  return privilages;
};

export const fileToText = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsText(file);
    reader.onload = () =>
      resolve(reader.result ? reader.result.toString() : "");
    reader.onerror = (error) => reject(error);
  });

export const getThreePointNumber = (number: number) => {
  return Number(number.toFixed(3));
};

export const getDeepCopy = <T>(params:T): T => JSON.parse(JSON.stringify(params))

export function formatDate(dateString:Date) {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  const formattedDay = day < 10 ? '0' + day : day;
  const formattedMonth = month < 10 ? '0' + month : month;

  return formattedDay + '-' + formattedMonth + '-' + year;
}

export const getMetalPrice = (pricingParameters: TBasePricingParameters, params: { metalType?: string, isCorporate?: boolean, isBuybackAssured?: boolean } = {}) => {
  const {
    gold_assured_buy_back_rate,
    gold_net_rate_jewellers,
    gold_net_rate_pvc_ecom,
    gold_non_assured_buy_back_rate,

    silver_assured_buy_back_rate,
    silver_net_rate_jewellers,
    silver_net_rate_pvc_ecom,
    silver_non_assured_buy_back_rate
  } = pricingParameters

  const {
    metalType,
    isCorporate,
    isBuybackAssured
  } = params

  if (metalType === METAL_TYPES.SILVER) {
    if (isBuybackAssured) {
      return silver_assured_buy_back_rate
    } else if (isBuybackAssured === false) {
      return silver_non_assured_buy_back_rate
    } else if (isCorporate) {
      return silver_net_rate_jewellers
    } else {
      return silver_net_rate_pvc_ecom
    }
  } else {
    if (isBuybackAssured) {
      return gold_assured_buy_back_rate
    } else if (isBuybackAssured === false) {
      return gold_non_assured_buy_back_rate
    } else if (isCorporate) {
      return gold_net_rate_jewellers
    } else {
      return gold_net_rate_pvc_ecom
    }
  }

}

export const getFormattedCurrency = (price: number | string, currencySign: boolean = false) => {
  if (typeof price === 'string') price = Number(price)
  const options: Intl.NumberFormatOptions = currencySign ? { style: 'currency', currency: 'INR' } : {}
  const inr = new Intl.NumberFormat('en-IN', options);
  return inr.format(Number(price.toFixed(2)))
}

export const mockRequest = <T>(params:T) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => resolve(params))
  })
}


export const getTwoPointNumber = (number: number) => {
  return Number(number.toFixed(2))
}

export const getPvcStateCode = (address: TPvcCenterAddress) => {
  if(!address) return ''
  return STATES.filter(state => state.value === address.state)[0]?.code || ''
}

export const isEmpty = (value: string | number | object | Array<any> | undefined | null) => {
  if(typeof value === 'undefined') return true
  if(value === null) return true
  if(typeof value === 'string' && value === '') return true
  if(typeof value === 'number' && Number.isNaN(value)) return true
  if(typeof value === 'object' && !Object.keys(value).length) return true
  return false
}

export const getAddressesOptions = (addresses: ICustomerAddress[] | TPvcCenterAddress[]) => {
  return addresses?.map(address => ({ label: address?.name + ' - ' + address?.line1 + ' - ' + address?.city, value: address.id }))
}